export default "__VITE_ASSET__HVd2nMrl__"